import { atom } from "recoil"

export const createContactModeState = atom<"New" | "Edit" | "EditReserved">({
  key: "atoms/contact/create/createContactModeState",
  default: "New",
})
